<template>
  <button>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "ButtonPrimary"
}
</script>

<style scoped>
button {
  height: 50px;
  line-height: 50px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 400;
  border-radius: 0;
  padding: 0 20px;
  min-width: 140px;
  outline: none;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  text-transform: capitalize;
  background-color: #f6483b;
  border: 1px solid #f6483b;
  transition: all 0.3s;
}
button:focus,
button:hover {
  color: #f6483b;
  background-color: #ffffff;
  border: 1px solid #f6483b;
  transition: all 0.3s;
}
</style>